import React, { Component, ReactNode } from 'react';

interface GlobalErrorBoundaryProps {
  children: ReactNode;
}

interface GlobalErrorBoundaryState {
  hasError: boolean;
}

class GlobalErrorBoundary extends Component<GlobalErrorBoundaryProps, GlobalErrorBoundaryState> {
  constructor(props: GlobalErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error: Error) {
    // You can log the error or send it to a server for tracking here

    //TODO - Use the Error Object definition the object structure and send to cloudflare endpoint

    console.error(error);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      
      
      //TODO: Clean up the UI here to show an error has occured


      return <div>Something went really wrong - check the console.</div>;
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
